// Token storage utility for JWT token management
const TOKEN_KEY = 'auth_token';

/**
 * Retrieve the JWT token from localStorage
 * @returns The token string or null if not found
 */
export const getToken = (): string | null => {
  return localStorage.getItem(TOKEN_KEY);
};

/**
 * Store the JWT token in localStorage
 * @param token The JWT token to store
 */
export const setToken = (token: string): void => {
  localStorage.setItem(TOKEN_KEY, token);
};

/**
 * Remove the JWT token from localStorage
 */
export const removeToken = (): void => {
  localStorage.removeItem(TOKEN_KEY);
};

/**
 * Check if a token exists
 * @returns true if token exists, false otherwise
 */
export const hasToken = (): boolean => {
  return getToken() !== null;
};
